module.exports = __webpack_public_path__ + "static/img/rule_content.1efa0e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/ares/secondAnniversary/rule_content.png
// module id = NQVF
// module chunks = 10